/**
 * Padding Fragment
 *
 * Common pattern for padding objects used in copy-block, image-slider, etc.
 */

/**
 * Field projection for padding
 * Can be interpolated into block queries
 */
export const paddingFields = `
  "top": padding.top,
  "bottom": padding.bottom
`
